import React from 'react';
interface TestimonialProps {
  name: string;
  title: string;
  quote: string;
}
export const Testimonial = ({
  name,
  title,
  quote
}: TestimonialProps) => {
  return <div className="bg-blue-50 p-5 rounded-lg shadow-sm border border-blue-100" data-id="element-225">
      <p className="italic mb-4" data-id="element-226">"{quote}"</p>
      <div data-id="element-227">
        <p className="font-bold" data-id="element-228">{name}</p>
        <p className="text-sm text-gray-600" data-id="element-229">{title}</p>
      </div>
    </div>;
};